import { FabricCanvas } from '@components/canvas'
import { fabricCanvas } from '@components/canvas/CanvasObject'

export function useCanvas(): FabricCanvas {
  return fabricCanvas
}
